export default function () {
  // https://inclusive-components.design/tabbed-interfaces/

  // Get relevant elements and collections
  const tabbed: HTMLElement | undefined = document.querySelector(
    ".tabbed"
  ) as HTMLElement;
  let tablist: HTMLElement | undefined;
  let tabs: NodeList | undefined;
  let panels: NodeList | undefined;
  if (tabbed) {
    tablist = tabbed.querySelector("ul") as HTMLElement;
    panels = tabbed.querySelectorAll('[id^="section"]');
  }
  if (tablist) {
    tabs = tablist.querySelectorAll("a");
  }
  const _tabs = tabs as NodeListOf<HTMLElement>;
  const _panels = panels as NodeListOf<HTMLElement>;

  // Add the tablist role to the first <ul> in the .tabbed container
  if (tablist) {
    tablist.setAttribute("role", "tablist");
  }

  if (tabs) {
    // Add semantics are remove user focusability for each tab
    tabs.forEach((tab: Node, i: number) => {
      const _tab = tab as HTMLElement;
      _tab.setAttribute("role", "tab");
      _tab.setAttribute("id", "tab" + (i + 1));
      _tab.setAttribute("tabindex", "-1");
      let parentNode = tab.parentNode as HTMLElement;
      parentNode?.setAttribute("role", "presentation");

      // Handle clicking of tabs for mouse users
      tab.addEventListener("click", (e) => {
        e.preventDefault();
        const currentTab: HTMLElement | null =
          tablist.querySelector("[aria-selected]");
        if (e.currentTarget !== currentTab) {
          switchTab(currentTab, e.currentTarget);
        }
      });

      // Handle keydown events for keyboard users
      tab.addEventListener("keydown", (e) => {
        // Get the index of the current tab in the tabs node list
        let index = Array.prototype.indexOf.call(tabs, e.currentTarget);
        const _e = e as KeyboardEvent;
        const _panels = panels as NodeListOf<HTMLElement>;
        // Work out which key the user is pressing and
        // Calculate the new tab's index where appropriate
        let dir: number | string | null = null;
        if (_e.key === "ArrowLeft") {
          dir = index - 1;
        } else if (_e.key === "ArrowRight") {
          dir = index + 1;
        } else if (_e.key === "ArrowDown") {
          dir = "down";
        } else {
          dir = null;
        }
        if (dir !== null) {
          e.preventDefault();
          // If the down key is pressed, move focus to the open panel,
          // otherwise switch to the adjacent tab
          if (dir === "down") {
            _panels[i].focus({ preventScroll: true });
          } else if (typeof dir === "number") {
            if (tabs[dir]) {
              switchTab(e.currentTarget, tabs[dir]);
            } else {
              void 0;
            }
          }
        }
      });
    });
  }

  if (panels) {
    // Add tab panel semantics and hide them all
    Array.prototype.forEach.call(panels, (panel, i) => {
      panel.setAttribute("role", "tabpanel");
      panel.setAttribute("tabindex", "-1");
      let id = panel.getAttribute("id");
      panel.setAttribute("aria-labelledby", _tabs[i].id);
      panel.hidden = true;
    });
  }

  if (tabs) {
    // Initially activate the first tab and reveal the first tab panel
    _tabs[0].removeAttribute("tabindex");
    _tabs[0].setAttribute("aria-selected", "true");
    _panels[0].hidden = false;
  }

  // The tab switching function
  const switchTab = (oldTab: any, newTab: any) => {
    newTab.focus({
      preventScroll: true,
    });
    // Make the active tab focusable by the user (Tab key)
    newTab.removeAttribute("tabindex");
    // Set the selected state
    newTab.setAttribute("aria-selected", "true");
    oldTab.removeAttribute("aria-selected");
    oldTab.setAttribute("tabindex", "-1");
    // Get the indices of the new and old tabs to find the correct
    // tab panels to show and hide
    let index = Array.prototype.indexOf.call(tabs, newTab);
    let oldIndex = Array.prototype.indexOf.call(tabs, oldTab);
    _panels[oldIndex].hidden = true;
    _panels[index].hidden = false;
  };
}
